import { render, staticRenderFns } from "./OrderHistoryPage.vue?vue&type=template&id=6934588c&scoped=true"
import script from "./OrderHistoryPage.vue?vue&type=script&lang=js"
export * from "./OrderHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./OrderHistoryPage.vue?vue&type=style&index=0&id=6934588c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6934588c",
  null
  
)

export default component.exports